import React from 'react'
import { ActiveLoansColumns, ActiveLoansTableData } from './ActiveLoansData';

import DataTable from '../../../../Common/DataTable/DataTable';
import DataTableHeader from '../../../../Common/DataTableHeader/DataTableHeader';
import DataTableFooter from '../../../../Common/DataTableFooter/DataTableFooter';

const
    ActiveLoansTable = ({ modalValue }) => {
        // {/* // x---------------------------------x ActiveLoansTable data // x---------------------------------x  */ }
        const dataT = ActiveLoansTableData.map((data) => {
            return {
                slNo: data.slNo,
                loanMoney: data.loanMoney,
                leftToRepay: data.leftToRepay,
                duration: data.duration,
                interestRate: data.interestRate,
                installment: data.installment,
                repay: (
                    <button type="button"
                        onClick={() => modalValue(true)}
                        className="border border-primary py-2 px-6 rounded-3xl hover:bg-primary hover:text-white">Repay</button>
                )
            };
        });
        return (
            <div className='px-3'>
                {/* // x---------------------------------x Common Table Import Ad  // x---------------------------------x  */}
                <DataTableHeader />
                <DataTable columns={ActiveLoansColumns} data={dataT} />
                <DataTableFooter dataT={dataT} />
            </div>
        )
    }

export default ActiveLoansTable